import { useParams } from 'react-router-dom';

import { useAuth, useAppDispatch, useAppSelector } from '@verantos-dev/core-annotation-tool';
import { selectBatchId } from '@verantos-dev/feature-supervisor-queue';

import { useGetSupervisorWorkspaceQuery } from '../../../../api/supervisorApiSlice';
import { useSupervisorMode } from '../../../../context/SupervisorModeContext';
import { setConflictsAllConceptsExpanded } from '../../../../state/supervisorSlice';

export const useConflictTab = () => {
  const { encounterId } = useParams();
  const { user } = useAuth();
  const { isReadOnly } = useSupervisorMode();
  const dispatch = useAppDispatch();
  const batchId = useAppSelector(selectBatchId);
  const {
    data: supervisorWorkspace,
    isLoading: isSupervisorWorkspaceLoading,
    isFetching: isSupervisorWorkspaceFetching,
  } = useGetSupervisorWorkspaceQuery(
    { encounterId: encounterId as string, batchId: batchId as string },
    { skip: !user.isUser && !isReadOnly }
  );

  // For concepts filter conflicts which are not resolved yet
  const conflictsInConcepts = supervisorWorkspace?.data.annotationsReview
    .map((item) => ({
      ...item,
      conflicts: item.conflicts.filter((conflict) => !conflict.resolved?.annotations?.length),
    }))
    .filter((item) => item.conflicts.length > 0);

  const setAllConceptsExpanded = () => dispatch(setConflictsAllConceptsExpanded(true));
  const clearAllConceptsExpanded = () => dispatch(setConflictsAllConceptsExpanded(false));

  return {
    conflictsInConcepts,
    conflictsLoading: isSupervisorWorkspaceFetching || isSupervisorWorkspaceLoading,
    setAllConceptsExpanded,
    clearAllConceptsExpanded,
  };
};
